require('./bootstrap');

import Vue from 'vue';
import VueZoomer from 'vue-zoomer';

window.Vue = Vue.default;

Vue.use(VueZoomer);

Vue.component("file-viewer", require("./components/FileViewer.vue").default);
Vue.component("drop-zone", require("./components/DropZone.vue").default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
  el: "#app"
});
